module.exports = __webpack_public_path__ + "static/img/discount_alert.40c9dbb.png";


//////////////////
// WEBPACK FOOTER
// ./app/v2/discount/images/discount_alert.png
// module id = 90
// module chunks = 1